export const IOD_SAVING_STATES = {
  SAVING: 'saving',
  JUST_SAVED: 'justSaved',
  UNSAVED_CHANGES: 'unsavedChanges',
  NO_CHANGES: 'noChanges'
} as const
